import {
    type DetectGpuRawResult,
    probeDetectGpuRaw,
    probeWebGl2,
    probeWebGpu,
    type WebGlProbeResult,
    type WebGpuProbeResult,
} from "utils/gpuDetection";

import { type GuidanceSnapshot } from "./guidanceModel";

let webgl: WebGlProbeResult | undefined;
let webgpu: Promise<WebGpuProbeResult> | undefined;
let detectGpuRaw: Promise<DetectGpuRawResult> | undefined;
let inFlight: Promise<GuidanceSnapshot | null> | null = null;

export function getCachedWebGl2(): WebGlProbeResult {
    if (!webgl) {
        webgl = probeWebGl2();
    }
    return webgl;
}

export function getCachedWebGpu(): Promise<WebGpuProbeResult> {
    if (!webgpu) {
        webgpu = probeWebGpu();
    }
    return webgpu;
}

export function getCachedDetectGpuRaw(): Promise<DetectGpuRawResult> {
    if (!detectGpuRaw) {
        detectGpuRaw = probeDetectGpuRaw();
    }
    return detectGpuRaw;
}

export function getGuidanceDetectionInFlight(): Promise<GuidanceSnapshot | null> | null {
    return inFlight;
}

export function setGuidanceDetectionInFlight(next: Promise<GuidanceSnapshot | null> | null): void {
    inFlight = next;
}

/** Clears probe results and the in-flight detection promise. Used by tests. */
export function resetGpuProbeCache(): void {
    webgl = undefined;
    webgpu = undefined;
    detectGpuRaw = undefined;
    inFlight = null;
}
